import React, { useState, useCallback, useContext, useEffect, useMemo } from 'react'
import { GetInTouch } from '@/custom/components/molecules/GetInTouch'
import './OemDetails.css'
import { OverViewLayout } from './OverViewLayout'
import ProductLayout from './ProductLayout'
import { useParams } from 'react-router-dom/cjs/react-router-dom'
import Banner from '@/custom/components/molecules/Banner'
import CustomBanner from '@/custom/components/atoms/CustomBanner'
import * as Yup from 'yup'
import CommonFront from '@/custom/context/frontCommon/settingContext'
import { useFormik } from 'formik'
import Search from '../Search'
import { is } from 'date-fns/locale'
import CommonContext from '@/custom/context/common/commonContext'
export const OemDetails = () => {
    const [mainData, setMainData] = useState({
        bgColor: 'rgb(206, 65, 65)',
        textColor: 'rgb(206, 65, 65)',
    })
    const commonFront = useContext(CommonFront)
    const { table_data_store, searchTableBrandStore } = commonFront
    const [mainDataBrand, setMainDataBrand] = useState({})
    const [bannerData, setBannerData] = useState([])
    const commonContext = useContext(CommonContext)
    const { searchValue, allCategory, allOem } = commonContext
    useEffect(() => {
        if (table_data_store) {
            if (table_data_store.from == 'searchTableBrandStore') {
                setBannerData(table_data_store.records.length ? table_data_store.records : [])
            }
        }
    }, [table_data_store])
    const params = useParams()
    useEffect(() => {
        if (params && allOem) {
            if (params.id && params.client_id) {
                let finder = allOem?.find((ele) => ele.id == params.id)

                if (finder?.id) {
                    setMainDataBrand(finder)
                    setMainData({
                        bgColor: finder.theme_color_code || 'rgb(206, 65, 65)',
                        textColor: finder.filter_color_code || 'rgb(206, 65, 65)',
                    })
                }
            }
        }
    }, [params.id, params.client_id, allOem])
    useEffect(() => {
        if (params && params.id) {
            searchTableBrandStore({ id: params.id }, 'searchTableBrandStore')
        }
    }, [params.id])

    // Formik validation schema

    const breadcrumbs = [
        { label: 'Home', link: '/' },
        { label: 'Brand Store', link: '/overview' },
    ]
    const pp = useMemo(() => {
        return {
            seller_user_id: {
                value: params.client_id,
                type: 'in',
                field: 'p.seller_user_id',
            },
            is_new: {
                value: '1',
                type: 'in',
                field: 'p.is_new',
            },
        }
    }, [params.client_id])

    return (
        <div className="oemDetalis">
            <div>
                <CustomBanner imageObject={bannerData} theme={mainData} />
            </div>
            <OverViewLayout
                title={mainDataBrand.title}
                description={mainDataBrand.description}
                breadcrumbs={breadcrumbs}
                theme={mainData}
            />
            {/* style={themeColorChange} */}
            <div className="productViewCont">
                {/* <ProductLayout theme={themeColorChange} /> */}
                <Search searchName={['categorytypes', 'model']} customFilter={pp} />
            </div>
            <div className="getInTouchConts" style={mainData}>
                <GetInTouch theme={mainData} />
            </div>
        </div>
    )
}
